import { ROLES } from './roles';

export const ACTION = {
  POP: 'POP',
  PUSH: 'PUSH',
  REPLACE: 'REPLACE'
};

export const ROUTE = {
  LOGIN: '/',
  DASHBOARD: '/:manufacturerRole/dashboard',
  INSPECTOR_DASHBOARD: '/inspectorDashboard',
  METRICS: '/metrics',
  SUMMARY: '/:manufacturerCode/:manufacturerRole/summary',
  REPORT: '/:manufacturerId/:manufacturerRole/report',
  BOAT_MANUFACTURER: `/:manufacturerCode/${ROLES.BOAT_MANUFACTURER.nameForUrl}`,
  TRAILER_MANUFACTURER: `/:manufacturerCode/${ROLES.TRAILER_MANUFACTURER.nameForUrl}`,
  COMPONENT_MANUFACTURER: `/:manufacturerCode/${ROLES.COMPONENT_MANUFACTURER.nameForUrl}`,
  OIL_MANUFACTURER: `/:manufacturerCode/${ROLES.OIL_MANUFACTURER.nameForUrl}`,
  OIL_BRANDER: `/:manufacturerCode/${ROLES.OIL_BRANDER.nameForUrl}`,
  INSPECTION: `/:manufacturerCode/:manufacturerRole/${ROLES.INSPECTION.nameForUrl}`,
  DOCUMENTS: '/:manufacturerCode/:manufacturerRole/documents',
};

export const LINK = {
  LIST: {
    TRAILER: 'trailer',
    COMPONENT: 'component'
  },
  MANUFACTURER: {
    TRAILER: 'trailer',
    COMPONENT: 'component',
    BOAT: 'boat',
    OIL: 'oil',
  }
};

export const HASH = {
  ADD: 'add',
  EDIT: 'edit'
};



// WEBPACK FOOTER //
// ./src/app/constants/routing.js